interface SvgProps {
	style?: object;
}

const NoticeIcon = ({ style }: SvgProps) => {
	return (
		<svg focusable="false" height="20" width="20" style={style}>
			<g transform="translate(0, 0) scale(1)">
				<path
					d="M0 10C0 4.486 4.486 0 10 0s10 4.486 10 10-4.486 10-10 10S0 15.514 0 10zm2 0c0 4.411 3.589 8 8 8s8-3.589 8-8-3.589-8-8-8-8 3.589-8 8zm9 .5v-5H9v5h2zM8.5 13a1.5 1.5 0 113.001.001A1.5 1.5 0 018.5 13z"
					fill="rgba(14, 14, 15, 1)"
				></path>
			</g>
		</svg>
	);
};

export default NoticeIcon;
